import { cn } from "@/utils/cn";

interface PricingPriceProps {
  className?: string;
  price: number;
}

function PricingPrice({ className, price }: PricingPriceProps) {
  return (
    <div className={cn("leading-none", className)}>
      <span className="mr-1 text-28 font-bold">{price}</span>
      <span className="mr-1 text-16">만원</span>
      <span className="text-14 font-light">/건</span>
    </div>
  );
}

export default PricingPrice;
